import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ZapOff, Home, Activity } from 'lucide-react';
import { Button } from './ui/button';

export const NotFoundPage = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-[70vh] flex flex-col items-center justify-center p-4 animate-in fade-in duration-500">
            <div className="max-w-md w-full text-center space-y-8">

                {/* Icon with subtle pulse effect */}
                <div className="relative inline-block">
                    <div className="absolute inset-0 bg-red-100 rounded-full animate-ping opacity-20 duration-[2000ms]"></div>
                    <div className="relative bg-red-50 p-8 rounded-full inline-flex items-center justify-center ring-1 ring-red-100">
                        <ZapOff className="w-16 h-16 text-red-500" strokeWidth={1.5} />
                    </div>
                </div>

                <div className="space-y-3">
                    <h1 className="text-4xl font-bold tracking-tight text-gray-900">
                        System Collapse (404)
                    </h1>
                    <p className="text-lg text-gray-600 leading-relaxed">
                        The transmission line to this page has tripped. It seems the content you are looking for is currently load-shedding.
                    </p>
                </div>

                <div className="flex flex-col sm:flex-row gap-3 justify-center pt-4">
                    <Button
                        size="lg"
                        onClick={() => navigate('/')}
                        className="gap-2 shadow-lg shadow-emerald-500/20 hover:shadow-emerald-500/30 transition-all bg-emerald-600 hover:bg-emerald-700"
                    >
                        <Home className="w-4 h-4" />
                        Restore Power
                    </Button>

                    <Button
                        variant="outline"
                        size="lg"
                        onClick={() => navigate('/grids')}
                        className="gap-2"
                    >
                        <Activity className="w-4 h-4" />
                        Check Grid Status
                    </Button>
                </div>

                <div className="text-xs font-mono text-gray-400 mt-12 bg-gray-50 inline-block px-3 py-1 rounded-full border border-gray-100">
                    Error Code: ZERO_MW_GENERATION
                </div>
            </div>
        </div>
    );
};
